import { Component, ViewEncapsulation, ContentChildren, QueryList, Input, Output, EventEmitter, AfterContentInit } from '@angular/core';
import { GainsTabComponent } from '../gains-tab/gains-tab.component';

@Component({
  selector: 'gains-tabset',
  standalone: false,
  templateUrl: './gains-tabset.component.html',
  styleUrls: ['./gains-tabset.component.scss'],
  encapsulation: ViewEncapsulation.None // Disable encapsulation to allow global style overrides
})
export class GainsTabsetComponent implements AfterContentInit {
  @ContentChildren(GainsTabComponent) tabs!: QueryList<GainsTabComponent>;

  _displayIndex = 0;
  private _selectedIndex = 0;

  @Input() set selectedIndex(val: number) {
    this._selectedIndex = val;
    this._displayIndex = val;
  }
  get selectedIndex(): number {
    return this._selectedIndex;
  }

  @Output() selectedIndexChange = new EventEmitter<number>();
  @Input() styleType = 'Inline';
  /** The tabs' size; small for Card, default for Inline unless given. */
  @Input() size?: 'small' | 'default' | 'large';
  @Input() canChange?: (from: number, to: number) => boolean;

  ngAfterContentInit(): void {
    if (this.tabs.length === 0) {
      throw new Error('No tabs provided to gains-tabset.');
    }
  }

  onTabChange(index: number): void {
    // Guard: nz-tabset fires nzSelectedIndexChange whenever [nzSelectedIndex] is set
    // programmatically, even if the value didn't change. Skip to prevent a feedback loop.
    if (index === this._displayIndex) {
      return;
    }
    if (this.canChange && !this.canChange(this._selectedIndex, index)) {
      const revertTo = this._selectedIndex;
      this._displayIndex = index;
      setTimeout(() => {
        this._displayIndex = revertTo;
      }, 0);
      return;
    }
    this._selectedIndex = index;
    this._displayIndex = index;
    this.selectedIndexChange.emit(index);
  }
}
